import { render, staticRenderFns } from "./BoatCard.vue?vue&type=template&id=6ec72ba6"
import script from "./BoatCard.vue?vue&type=script&lang=js"
export * from "./BoatCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports